import { v4 as uuidv4 } from 'uuid';

/**
 * Generates a proper UUID v4
 * @returns A UUID v4 string
 */
export const generateUUID = (): string => {
  return uuidv4();
};

/**
 * Generates a temporary UUID for frontend-only entities
 * @returns A UUID v4 string with 'temp_' prefix
 */
export const generateTempUUID = (): string => {
  return `temp_${uuidv4()}`;
};

/**
 * Checks if a UUID is temporary (starts with 'temp_')
 * @param uuid The UUID to check
 * @returns True if the UUID is temporary
 */
export const isTempUUID = (uuid: string): boolean => {
  return uuid.startsWith('temp_');
};

/**
 * Removes the 'temp_' prefix from a UUID
 * @param uuid The UUID to clean
 * @returns The UUID without the 'temp_' prefix
 */
export const cleanTempUUID = (uuid: string): string => {
  return uuid.replace(/^temp_/, '');
};
